<template>
    <div class="warp">
        <div class="widget_title">
            <span @click="routerPath" class="router_tag">···</span>
            <div class="name_box">
                <div class="wedget_name cont_text_overflow" :title="title">{{title}}<slot name="title"></slot></div>
                <slot name="choose_info"></slot>
            </div>
        </div>
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props:{
            title:{
                type:String
            },
            router:{
                type:String
            }
        },
        data(){
            return {
               
            }
        },
        methods: {
            routerPath(){
                if(this.router)
                  this.$irouter({name:this.router});
            }
        }
    }
</script>
<style lang="less" scoped>
    .warp{
        position: relative;
        /* padding: 20px 24px; */
    }
    .widget_title{
        line-height: 20px;
        font-size: 16px;
        &>span{
            float: right;
            color:#c7cbd4;
            letter-spacing: 2px;
            font-weight: bold;
            font-size: 14px;
        }
        .name_box{
            margin-right: 30px;
            display: flex;
            .wedget_name{
                flex-grow: 1;
                cursor:pointer;
            }
            span{
                margin-right:10px;
                cursor:pointer;
            }
            span:hover{
                color: #4183fc;
            }
            .is_active{
                color: #4183fc;
            }
        }
        .router_tag{
            cursor: pointer;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/warp.vue